import React, { useEffect } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { SuccessInsert } from '../components/SuccessInsert';
import { ConnectionInsert } from '../components/ConnectionInsert';
import { BundleSection } from '../components/BundleSection';
import { OrderBumpSection } from '../components/OrderBumpSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { DecisionSection } from '../components/DecisionSection';
import { FAQSection } from '../components/FAQSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { StickyButton } from '../components/StickyButton';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-charcoal relative overflow-x-hidden" data-id="element-298">
      <AnnouncementBar data-id="element-299" />
      <HeroSection data-id="element-300" />
      <SocialProofSection data-id="element-301" />
      <SuccessInsert data-id="element-302" />
      <ConnectionInsert data-id="element-303" />
      <BundleSection data-id="element-304" />
      <OrderBumpSection data-id="element-305" />
      <TestimonialsSection data-id="element-306" />
      <DecisionSection data-id="element-307" />
      <FAQSection data-id="element-308" />
      <ContactSection data-id="element-309" />
      <Footer data-id="element-310" />
      <StickyButton data-id="element-311" />
    </main>;
}